import { useCallback, useRef } from 'react';
export const useKeyboard = ({ controls, direction, onFocus, onPress, }) => {
    const refs = useRef({});
    const setRef = useCallback((value) => (el) => {
        refs.current[value] = el;
    }, []);
    const focusControl = useCallback((control) => {
        var _a;
        (_a = refs.current[control.value]) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    const getNextControl = useCallback((currentIndex, navDirection) => {
        const totalControls = controls.length;
        if (totalControls === 0) {
            return null;
        }
        let nextIndex = navDirection === 'next'
            ? (currentIndex + 1) % totalControls
            : currentIndex === 0
                ? totalControls - 1
                : currentIndex - 1;
        let attempts = 0;
        while (controls[nextIndex].disabled && attempts < totalControls) {
            nextIndex =
                navDirection === 'next'
                    ? (nextIndex + 1) % totalControls
                    : nextIndex === 0
                        ? totalControls - 1
                        : nextIndex - 1;
            attempts++;
        }
        return controls[nextIndex];
    }, [controls]);
    const handleArrowNavigation = useCallback((currentIndex, key, isVertical) => {
        const isHorizontalKey = key === 'ArrowLeft' || key === 'ArrowRight';
        const isVerticalKey = key === 'ArrowUp' || key === 'ArrowDown';
        if ((isVertical && !isVerticalKey) || (!isVertical && !isHorizontalKey)) {
            return false;
        }
        const navDirection = key === 'ArrowRight' || key === 'ArrowDown' ? 'next' : 'prev';
        const nextControl = getNextControl(currentIndex, navDirection);
        if (nextControl && !nextControl.disabled) {
            onPress(nextControl);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(nextControl);
            focusControl(nextControl);
        }
        return true;
    }, [focusControl, getNextControl, onFocus, onPress]);
    const onKeyDown = useCallback((event, currentControl) => {
        const currentIndex = controls.findIndex((control) => control.value === currentControl.value);
        const isVertical = direction === 'vertical';
        switch (event.key) {
            case 'ArrowRight':
            case 'ArrowLeft':
            case 'ArrowDown':
            case 'ArrowUp': {
                if (currentControl.disabled) {
                    return;
                }
                const wasHandled = handleArrowNavigation(currentIndex, event.key, isVertical);
                if (wasHandled) {
                    event.preventDefault();
                }
                break;
            }
            case 'Home': {
                event.preventDefault();
                const firstEnabledControl = controls.find((control) => !control.disabled);
                if (firstEnabledControl) {
                    onPress(firstEnabledControl);
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus(firstEnabledControl);
                    focusControl(firstEnabledControl);
                }
                break;
            }
            case 'End': {
                event.preventDefault();
                const lastEnabledControl = controls
                    .slice()
                    .reverse()
                    .find((control) => !control.disabled);
                if (lastEnabledControl) {
                    onPress(lastEnabledControl);
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus(lastEnabledControl);
                    focusControl(lastEnabledControl);
                }
                break;
            }
        }
    }, [
        controls,
        direction,
        focusControl,
        handleArrowNavigation,
        onFocus,
        onPress,
    ]);
    return { onKeyDown, setRef };
};
//# sourceMappingURL=useKeyboard.js.map